import React, { useEffect, useState, useRef } from "react";
import {
  fetchAllMarketCategoriesBestbetsAll,
  fetchAllMarketCategories
} from "../../api/api";
// import HistoryModel from "./History"
// import { totalOddsCal } from "../../helper/index"
import Accordion from "../Accordion";

const BuildbetAllData = ({
  matchId,
  oddsFormat,
  language,
}) => {
  const [allMarketCategoriesData, setallMarketCategoriesData] = useState([]);
  const [activeButton, setActiveButton] = useState(1);
  const [activeMarketName, setActiveMarketName] = useState('Match');
  const [allMarketData, setAllMarketData] = useState([]);
  const [showHistory, setShowHistory] = useState(null);
  const [alert, setAlert] = useState("");
  const [expandedrtb, setexpandedrtb] = useState(null);
  const [match_id, setMatch_id] = useState();
  const hasFetched = useRef(false);
  const [loading, setLoading] = useState(false);
  const [category, setCategory] = useState([])
  
  const handleShowComplementaryStat = (index) => {
    setexpandedrtb(expandedrtb === index ? null : index);
  };
  
  const handleOpenModal = (index) => {
    setShowHistory(index);
  };

  const handleCloseModal = (e) => {
    e.stopPropagation();
    setShowHistory(null);
  };

  useEffect(() => {
    const MarketCategory = async () => {
      const resData = await fetchAllMarketCategories(1, language, 5);
      const category_data = resData.data;
      setCategory(category_data);
    };
    MarketCategory();
  }, [language]);


  useEffect(() => {
    if (!matchId) return;
    if (hasFetched.current === matchId) return;

    hasFetched.current = matchId;

    const allMarketCategory = async () => {
      setLoading(true)
      setActiveButton(1);
      const resData = await fetchAllMarketCategoriesBestbetsAll(1, language, 5, matchId);
      const category_data = resData.data;
      if (category_data && Object.keys(category_data).length > 0) {
        setMatch_id(category_data.matchid);
        setallMarketCategoriesData(category_data.bestbet);
        const filteredData = category_data.bestbet.filter(
          (item) => item.marketcategoryid === 1
        );
        setAllMarketData(filteredData);
        setLoading(false)
      } else {
        setallMarketCategoriesData([]);
        setAlert("No data available");
        setLoading(false)
      }
    };
    allMarketCategory();
  }, [language, matchId]);


  const handleButtonClick = async (marketcategoryid, marketName) => {
  setActiveButton(marketcategoryid);
  setActiveMarketName(marketName)

  const filteredData = allMarketCategoriesData.filter(
    (item) => item.marketcategoryid === marketcategoryid
  );
  if(filteredData){
    setAllMarketData(filteredData);
  }else{
    setAllMarketData([])
  }
};


  return (
    <>

      <div className="AF-widget__content">
        <div className="AF-matchBoxGroup__container">
          {category ? (
            category.map((item) => (
              <div
                key={item.marketcategoryid}
                className="AF-matchBoxGroup__item"
              >
                <button
                  id="btn_all_marketcategory"
                  className={`btn  ${
                    activeButton === item.marketcategoryid
                      ? "btn-custom-active"
                      : "btn-custom-inactive"
                  }`}
                  onClick={() => handleButtonClick(item.marketcategoryid, item.marketcategory)}
                >
                  <span className="">{item.marketcategory}</span>
                </button>
              </div>
            ))
          ) : (
            <div className="loading-container">
              <div className="spinner"></div>
            </div>
          )}
        </div>

        <div style={{ marginBottom: "5px" }}>
          {allMarketCategoriesData.length > 0 ? (
            <Accordion
              data={allMarketData}
              allMarketCategoriesData={allMarketCategoriesData}
              matchId={match_id}
              handleCloseModal={handleCloseModal}
              handleOpenModal={handleOpenModal}
              showHistory={showHistory}
              expandedrtb={expandedrtb}
              handleShowComplementaryStat={handleShowComplementaryStat}
              oddsFormat={oddsFormat}
              activeButton={activeButton}
              activeMarketName={activeMarketName}
              language={language}
            />
          ) : (
            loading ? 
              <div className="loading-container">
                  <div className="spinner"></div>
                </div>
            :alert ? <div className="AF-error-message">No data available</div>:""
          )}
        </div>
      </div>
    </>
  );
};

export default BuildbetAllData;
